import { CurrentClientContract } from 'models'

export const GET_CLIENT_LOADED = 'GET_CLIENT_LOADED'
export const SET_CONNECTION_ID = 'SET_CONNECTION_ID'
export const SET_CUSTOMER_DISPLAY_SETTING = 'SET_CUSTOMER_DISPLAY_SETTING'
interface IState {
    currentClient?: CurrentClientContract
    connectionId: string | null
}

const initialState = {
    currentClient: undefined,
    connectionId: null,
}

const clientReducer = (state: IState = initialState, action: any): IState => {
    switch (action.type) {
        case SET_CUSTOMER_DISPLAY_SETTING: {
            return {
                ...state,
                currentClient: {
                    ...state.currentClient,
                    customerDisplaySettingEnable: action.payload,
                },
            }
        }
        case GET_CLIENT_LOADED: {
            return {
                ...state,
                currentClient: action.payload,
            }
        }
        case SET_CONNECTION_ID:
            return {
                ...state,
                connectionId: action.payload,
            }
        default:
            return state
    }
}

export default clientReducer
